import { queryKeys } from 'hooks/queryKeys';
import type { Payment } from 'models/payment';
import {
  type OrderService,
  orders as ordersService,
} from 'services/apiV3/orders/orders';
import {
  type PaymentsService,
  payments as paymentsService,
} from 'services/payex/payments/payments';

type ByOrderParams = {
  orderId: string;
  token: string;
  locale: string;
};

type ByIdParams = {
  id: string;
  locale: string;
};

const PAYMENT_NOT_FOUND = 'Payment not found';

export const paymentQueries = {
  byOrder: (
    { orderId, token, locale }: ByOrderParams,
    orders: Pick<OrderService, 'fetchPayment'> = ordersService,
  ) => ({
    queryKey: queryKeys.payment.byOrder(orderId, locale),
    queryFn: async (): Promise<Payment> => {
      const response = await orders.fetchPayment({ orderId, token, locale });
      const payment = response[response.length - 1];

      if (!payment) {
        throw new Error(PAYMENT_NOT_FOUND);
      }

      return payment;
    },
    staleTime: 0,
    retry: false,
  }),
  byId: (
    { id, locale }: ByIdParams,
    payments: Pick<PaymentsService, 'fetchById'> = paymentsService,
  ) => ({
    queryKey: queryKeys.payment.byId(id, locale),
    queryFn: async (): Promise<Payment> => {
      const payment = await payments.fetchById({ id, locale });

      if (!payment) {
        throw new Error(PAYMENT_NOT_FOUND);
      }

      return payment;
    },
    staleTime: 0,
    retry: false,
  }),
};
